<template>
  <sky-charts ref="chart"
              :config="chartConfig"
              legendPosition="bottom"
              :showTitle="false"
              :showShadow="false"
              :chartData="data"
              :extend="extend">
    <div slot="header"
         class="header">
      <div class="title">国家/地区</div>
      <div class="total-title">共<strong style="font-size:24px">{{getCountryCount}}</strong>个国家/地区</div>
    </div>
    <div slot="left"
         class="tab-bar">
      <fb-card-item v-for="(item,i) in cardList"
                    :key="item.type"
                    :active="type==item.type"
                    @click.native="changes(item.type,i)"
                    :label="item.label"
                    :value="item.value"
                    :tips="item.tips"></fb-card-item>
    </div>
  </sky-charts>
</template>

<script>
import mixins from "./ga_mixins";
import { nameMap } from "@/common/dictionary.js";
import filters from "@/mixins/filters.js";
import fbCardItem from "@/components/report/fb_card_item.vue";

export default {
  name: "ga_map",
  mixins: [mixins],
  components: {
    fbCardItem,
  },
  computed: {
    getCountryCount () {
      return this.data && Array.isArray(this.data) ? this.data.length : 0
    },
    cardList () {
      return [
        {
          type: 'impressions',
          label: '展示次数',
          value: filters.filters.thousands(this.impressions),
          tips: '广告在屏幕上展示的次数',
          sub: '展示占比'
        },
        {
          type: 'covers',
          label: '覆盖人数',
          value: filters.filters.thousands(this.covers),
          tips: '至少查看广告一次的用户数量，覆盖人数与展示次数不同，后者可能存在同一用户多次浏览广告的情况',
          sub: '覆盖占比'
        },
        {
          type: 'exchangeRateCost',
          label: '总消耗',
          value: filters.filters.rmb(this.exchangeRateCost),
          tips: '筛选时间周期内总支出',
          sub: '消耗占比'
        },
      ]
    }
  },
  data () {
    const that = this;
    return {
      filters,
      extend: {
        series: {
          type: 'map',
          nameMap
        },
        legend: {
          show: false,
        },
        visualMap: {
          show: true,
          left: '20%',
          orient: 'horizontal',
          min: 0,
          max: 12000,
          text: ["高", "低"],
          calculable: true,
          color: ["#026ACA", "#ABD7FF"]
        },
        tooltip: {
          formatter (val) {
            if (val && val.data) {
              let percentage = that.type + 'Percentage'
              let name = val.seriesName.substring(0, 2)
              let format = name === '消耗' ? 'rmb' : 'thousands'
              return `
                ${val.name} <br/>
                ${val.seriesName}：${filters.filters[format](val.value)}</br>
                ${name}占比：${that.data[val.dataIndex][percentage]}%
            `;
            }
          }
        }
      },
      lineConf: {
        type: "veBar"
      },
      chartConfig: {
        height: "500px",
        afterConfig: that.afterConf,
        columns: [],
        type: "veMap",
        chartSettings: {
          labelMap: {
            'impressions': '展示次数',
            'covers': '覆盖人数',
            'exchangeRateCost': '消耗'
          },
          aspectScale: "1",
          zoom: 1,
          label: false,
          scaleLimit: {
            min: 0.5,
            max: 2
          }
        }
      },
      data: [],
      dataMap: {
        'covers': 'countryRegionCoversList',
        'impressions': 'countryRegionImpressionsList',
        'exchangeRateCost': 'countryRegionExchangeRateCostList'
      },
      type: 'impressions',
      typeIndex: 0,
      impressions: 0,
      exchangeRateCost: 0,
      covers: 0
    };
  },

  watch: {
    condition: {
      handler (val) {
        if (val && val.countryList) {
          this.data = val.countryList
          this.getTotalNum()
          this.extend.visualMap.max = this.condition.maxImpressions
          this.chartConfig.chartSettings.position = "world";
          this.lineConf.columns = this.chartConfig.columns = [
            "countryRegionCn",
            "impressions"
          ];
        } else {
          this.data = null
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    afterConf (options) {
      const that = this
      if (options && Array.isArray(options.series)) {
        Object.assign(options.series[0], {
          left: 40,
          right: "50%"
        });
        options.series.push({
          type: 'bar',
          name: that.lineConf.columns[1],
          data: that.condition[that.dataMap[that.type]].map(item => item[that.lineConf.columns[1]]).reverse(),
          tooltip: {
            formatter (val) {
              let index = that.condition[that.dataMap[that.type]].length - 1 - val.dataIndex
              let percentage = val.seriesName + 'Percentage'
              let barItem = that.cardList[that.typeIndex]
              let format = val.seriesName === 'exchangeRateCost' ? 'rmb' : 'thousands'
              return `
                ${val.name}</br>
                ${barItem.label}：${filters.filters[format](val.value)}</br>
                ${barItem.sub}:${that.condition[that.dataMap[that.type]][index][percentage]}%
              `;
            }
          },
          itemStyle: {
            color: ['#1890FF'],
          }
        })
        options.xAxis = [
          {
            position: "top",
            type: "value"
          }
        ];
        options.yAxis = [
          {
            type: "category",
            data: this.condition[this.dataMap[this.type]].map(item => item[this.lineConf.columns[0]]).reverse()
          }
        ];
        options.grid = {
          width: "45%",
          right: 50
        };
      }
      return options;
    },
    getTotalNum () {
      this.impressions = this.condition.totalImpressions
      this.exchangeRateCost = this.condition.totalExchangeRateCost
      this.covers = this.condition.totalCovers
    },
    changes (type, index) {
      if (this.type != type) {
        let name = type.substring(0, 1).toUpperCase() + type.substring(1)
        this.type = type
        this.typeIndex = index
        this.extend.visualMap.max = this.condition[`max${name}`]
        this.lineConf.columns = this.chartConfig.columns = ["countryRegionCn", type];
        this.$refs.chart && this.$refs.chart.initCharts();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 16px;
  font-weight: bold;
  .total-title {
    padding: 30px 0 0 20px;
    font-size: 18px;
  }
}
.tab-bar {
  width: 30%;
  max-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
